import { useAuth0 } from '@auth0/auth0-react'
import { Link } from 'gatsby'
import React, { useContext } from 'react'

import { LocaleContext } from '../../locale/i18n'
import { staticPagePaths } from '../../locale/pathing'
import { StaticPage } from '../../logic/staticPage'
import Button from '../Button'

import './LoggedInMenu.scss'

function LogoutButton() {
  const { isAuthenticated, logout } = useAuth0()

  return isAuthenticated ? (
    <Button
      variant="link"
      onClick={() => {
        void logout({ logoutParams: { returnTo: window.location.origin } })
      }}
    >
      Log out
    </Button>
  ) : null
}

const LoggedInMenu = () => {
  const { user } = useAuth0()
  const { locale, t } = useContext(LocaleContext)

  if (!user) {
    return null
  }

  return (
    <div className="loggedInMenu">
      <div className="gutter gutter--center">
        <div className="loggedInMenu__container">
          <div className="loggedInMenu__nav">
            <Link
              className="loggedInMenu__link"
              activeClassName="active"
              to={staticPagePaths[StaticPage.PORTAL][locale]}
            >
              {t('portal.offersAndOrders')}
            </Link>
            <Link
              className="loggedInMenu__link"
              activeClassName="active"
              to={staticPagePaths[StaticPage.SHIPPING_INSTRUCTIONS][locale]}
            >
              {t(`nav.${StaticPage.SHIPPING_INSTRUCTIONS}`)}
            </Link>
          </div>
          <div className="loggedInMenu__spacer" />
          <div className="loggedInMenu__user">
            <img
              className="h-6 w-6 rounded-full"
              src={user.picture}
              alt={user.name}
            />
            <span className="loggedInMenu__name">{user.name}</span>
            <LogoutButton />
          </div>
        </div>
      </div>
    </div>
  )
}

export default LoggedInMenu
